import script from "./SportEventList.vue?vue&type=script&setup=true&lang=js"
export * from "./SportEventList.vue?vue&type=script&setup=true&lang=js"

import "./SportEventList.vue?vue&type=style&index=0&id=3b983661&lang=scss"

const __exports__ = script;

export default __exports__